import {
  faFile,
  faFileCad,
  faFileCsv,
  faFileDoc,
  faFileEps,
  faFileGif,
  faFileJpg,
  faFileMov,
  faFileMp3,
  faFileMp4,
  faFilePdf,
  faFilePng,
  faFilePpt,
  faFileSvg,
  faFileXls,
  faFileXml,
  faFileZip,
} from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const fileIconMap = {
  any: () => {
    return (
      <FontAwesomeIcon
        className="k-vertical-align-center k-mr-2"
        icon={faFile}
        fontSize={24}
      />
    );
  },
  ".csv": () => {
    return (
      <FontAwesomeIcon
        className="k-vertical-align-center k-mr-2"
        icon={faFileCsv}
        fontSize={24}
      />
    );
  },
  ".pdf": () => {
    return (
      <FontAwesomeIcon
        className="k-vertical-align-center k-mr-2"
        icon={faFilePdf}
        fontSize={24}
      />
    );
  },
  ".xml": () => {
    return (
      <FontAwesomeIcon
        className="k-vertical-align-center k-mr-2"
        icon={faFileXml}
        fontSize={24}
      />
    );
  },
  ".xls": () => {
    return (
      <FontAwesomeIcon
        className="k-vertical-align-center k-mr-2"
        icon={faFileXls}
        fontSize={24}
      />
    );
  },
  ".xlsx": () => {
    return (
      <FontAwesomeIcon
        className="k-vertical-align-center k-mr-2"
        icon={faFileXls}
        fontSize={24}
      />
    );
  },
  ".zip": () => {
    return (
      <FontAwesomeIcon
        className="k-vertical-align-center k-mr-2"
        icon={faFileZip}
        fontSize={24}
      />
    );
  },
  ".svg": () => {
    return (
      <FontAwesomeIcon
        className="k-vertical-align-center k-mr-2"
        icon={faFileSvg}
        fontSize={24}
      />
    );
  },
  ".ppt": () => {
    return (
      <FontAwesomeIcon
        className="k-vertical-align-center k-mr-2"
        icon={faFilePpt}
        fontSize={24}
      />
    );
  },
  ".png": () => {
    return (
      <FontAwesomeIcon
        className="k-vertical-align-center k-mr-2"
        icon={faFilePng}
        fontSize={24}
      />
    );
  },
  ".mp4": () => {
    return (
      <FontAwesomeIcon
        className="k-vertical-align-center k-mr-2"
        icon={faFileMp4}
        fontSize={24}
      />
    );
  },
  ".mp3": () => {
    return (
      <FontAwesomeIcon
        className="k-vertical-align-center k-mr-2"
        icon={faFileMp3}
        fontSize={24}
      />
    );
  },
  ".mov": () => {
    return (
      <FontAwesomeIcon
        className="k-vertical-align-center k-mr-2"
        icon={faFileMov}
        fontSize={24}
      />
    );
  },
  ".jpg": () => {
    return (
      <FontAwesomeIcon
        className="k-vertical-align-center k-mr-2"
        icon={faFileJpg}
        fontSize={24}
      />
    );
  },
  ".gif": () => {
    return (
      <FontAwesomeIcon
        className="k-vertical-align-center k-mr-2"
        icon={faFileGif}
        fontSize={24}
      />
    );
  },
  ".eps": () => {
    return (
      <FontAwesomeIcon
        className="k-vertical-align-center k-mr-2"
        icon={faFileEps}
        fontSize={24}
      />
    );
  },
  ".doc": () => {
    return (
      <FontAwesomeIcon
        className="k-vertical-align-center k-mr-2"
        icon={faFileDoc}
        fontSize={24}
      />
    );
  },
  ".docx": () => {
    return (
      <FontAwesomeIcon
        className="k-vertical-align-center k-mr-2"
        icon={faFileDoc}
        fontSize={24}
      />
    );
  },
  ".cad": () => {
    return (
      <FontAwesomeIcon
        className="k-vertical-align-center k-mr-2"
        icon={faFileCad}
        fontSize={24}
      />
    );
  },
};
